import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Table from '@mui/material/Table';
import HistoryIcon from '@mui/icons-material/History';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import AddCardIcon from '@mui/icons-material/AddCard';
import Collapse from '@mui/material/Collapse';

import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';


export default class  Addschedulebox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {open:false,stsdate:'',errormessage:'',erropen:false,alerttyep:"error",stsdate1:'',lcid:'1',staff:'0',slotid:'',locid:'',type:'',staffarray:[],slotData:[],exdisable:false,btnSaveor:'Save'}
	  
   }
   handleClickClose= (e) => { this.setState({open:!this.state.open,}); }
     handleClickOpen = (e) => {
	 

	  var date = new Date();
	  
	   var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ stsdate:dayjs(date),
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 ,open:!this.state.open,type:this.props.type});
	  this.onloadStaffbind();this.onloadslot();
	   }
	  
   onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({  staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
		
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
      })   
    }
	
	
onloadslot(){
		
		axios.post(Serverurl+'ajaxslotmanagement.php?action=getall&sm_slottype='+this.props.type+'&sorting=sm_order')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						slotData:resp.data	
							},()=>{
								
								
								 let slotApi = this.state.slotData.map(row => {
                          
          return {value:row.sm_id,display:row.sm_slotname}
        });
      
		
        this.setState({
          slotData: [{value: '0', display:'Select Slot'}].concat(slotApi)
        });
								
							})

	
			}else{
				this.setState({slotData:[]});
			}
 
    });
		
	}
	Markaspaid(orid,amt,session)
{
	let r = window.confirm("Do you want to Mark as Paid?");
	if(r == true){ 
		var formData = new FormData();
		formData.append('action','Paymentstatus')
		formData.append('op_trackinginfo','')
		formData.append('or_id',orid)
		formData.append('or_sesssion',session)
	    formData.append('or_totalamount',amt)
		axios.post(Serverurl+"ajaxorders.php", formData).then(res => {
					
				this.props.updateDonenew();
		});
	}		 
}
	myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});
  } 
    handnodateChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ stsdate:dayjs(date),
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({lcid: event.target.value});
	}
  handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  handleSave=(event)=>{
	let stsdate1 = this.state.stsdate1;

let slotid = this.state.slotid;	

let staff = this.state.staff;
  
if(stsdate1==="")
{
	
	this.setState({errormessage:"Please Enter Date",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(this.props.type!=="3"  && this.props.type!=="4")
{
if(staff==="")
{
	
	this.setState({errormessage:"Please Select Staff",erropen:true});
		 window.scrollTo({  top: 0  })
		 return false;
		
}
}
this.setState({errormessage:"",erropen:false,exdisable:true,btnSaveor:'Processing...'});

var formData = new FormData();
formData.append('action','extend') 
formData.append('or_enddate',stsdate1)

  formData.append('or_id',this.props.orid)
   
    formData.append('or_classtype',this.props.type)
	 formData.append('userid',localStorage.getItem("AYLuserid")) 
	 formData.append('or_cu_id',staff)
	 
	 	 formData.append('userid',localStorage.getItem("AYLuserid"))
	 axios.post(Serverurl+"ajaxorders.php", formData, {
        }).then(res => {
			
			if(res.data ===-1)
				{
				this.setState({errormessage:"Please check with another Staff",erropen:true,exdisable:false,btnSaveor:'Save'});	
				}
				else if(res.data ===0)
				{
					this.setState({errormessage:"Please check with another date and slot",erropen:true,exdisable:false,btnSaveor:'Save'});
				
					
		}else{
			this.setState({errormessage:"Request accepted successfully",alertype:"info",erropen:true,exdisable:false,btnSaveor:'Save',open:false},()=>{this.props.updateDonenew();});
		}
		
  });
  }
  render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	  Extend Subscription
	  </DialogTitle>
      <DialogContent><p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>  <div className="scheduelpop">
	  <ul>
	  <li><p><span className="validation">*</span> Date
		</p>
	<p>
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.stsdate) }
className="txtbox" minDate={dayjs(Date.now()) }


    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
	</p>
	  </li>
	  {(this.props.type!=="3"  && this.props.type!=="4") && ( 
<li><p><span className="validation">*</span> Select Staff</p>
<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
</li>
	  )}

</ul>

		
       <div className="actionbtn">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleSave} disable={this.state.exdisable} className="frmSecondarybtn">
			{this.state.btnSaveor}
        </Button>
		</div></div>
<div className="clear"></div>	</div>
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
}






